import AuthLogo from './AuthLogo';

// Auth V1 shared presentation shell. Desktop: delivered plate full-bleed, environment left,
// dark glass panel right. Mobile: portrait plate, form-priority. Layout only — no auth logic.
const Plates = () => (
  <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
    <img
      src="/auth/v1/auth-mobile-640.webp"
      srcSet="/auth/v1/auth-mobile-640.webp 640w, /auth/v1/auth-mobile-828.webp 828w"
      sizes="100vw"
      alt=""
      className="lg:hidden w-full h-full object-cover object-center"
      draggable="false"
    />
    <img
      src="/auth/v1/auth-desktop-1440.webp"
      srcSet="/auth/v1/auth-desktop-1440.webp 1440w, /auth/v1/auth-desktop-1920.webp 1920w"
      sizes="100vw"
      alt=""
      className="hidden lg:block w-full h-full object-cover object-center"
      draggable="false"
    />
    <div
      className="absolute inset-0 lg:hidden"
      style={{
        background:
          'linear-gradient(to bottom, rgba(8,7,14,0.30) 0%, rgba(8,7,14,0.48) 42%, rgba(8,7,14,0.82) 100%)',
      }}
    />
    <div
      className="absolute inset-0 hidden lg:block"
      style={{
        background:
          'linear-gradient(to right, rgba(8,7,14,0.18) 0%, rgba(8,7,14,0.02) 42%, rgba(8,7,14,0.18) 72%, rgba(8,7,14,0.30) 100%)',
      }}
    />
  </div>
);

export const AuthShell = ({ children, header, testId, logoWidth = 148 }) => (
  <div
    className="relative min-h-screen min-h-[100dvh] w-full overflow-x-hidden"
    style={{ background: '#08070E' }}
    data-testid={testId}
  >
    <Plates />

    {header && (
      <div className="absolute top-0 left-0 z-30 px-5 pt-8 lg:pt-10">{header}</div>
    )}

    <div className="relative z-10 flex min-h-screen min-h-[100dvh] w-full lg:justify-end">
      <div className="hidden lg:block flex-1" />

      <div
        className="w-full lg:w-[44%] lg:min-w-[430px] lg:max-w-[580px] flex flex-col overflow-y-auto px-6 sm:px-10 lg:px-14 lg:border-l lg:border-white/[0.06] lg:bg-[linear-gradient(to_right,rgba(10,9,17,0.16),rgba(10,9,17,0.40))] lg:backdrop-blur-[14px]"
        data-testid="auth-panel"
      >
        <div
          className="w-full max-w-sm mx-auto my-auto pt-24 pb-10 lg:pt-10 lg:pb-10"
          style={{ paddingBottom: 'max(2.5rem, env(safe-area-inset-bottom))' }}
        >
          <div className="rounded-3xl bg-[rgba(9,8,16,0.38)] backdrop-blur-[10px] px-5 py-8 lg:rounded-none lg:bg-transparent lg:backdrop-blur-none lg:px-0 lg:py-0">
            <div className="flex justify-center mb-8">
              <AuthLogo width={logoWidth} />
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AuthShell;
